<script setup>
import { computed } from "vue";

const props = defineProps({
  invoice: {
    type: Object,
    required: true,
  },
});

const formatDate = (value) => {
  if (!value) return "-";
  return new Intl.DateTimeFormat("th-TH", {
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(new Date(value));
};

const infoItems = computed(() => [
  { label: "เลขที่ใบแจ้งหนี้", value: props.invoice.invoiceNo },
  { label: "รอบบิล", value: props.invoice.billingMonth },
  { label: "วันที่ออกบิล", value: formatDate(props.invoice.issueDate) },
  { label: "ครบกำหนดชำระ", value: formatDate(props.invoice.dueDate) },
  { label: "อาคาร", value: props.invoice.building },
  { label: "ยูนิต", value: props.invoice.unitCode },
]);

const statusText = (status) => {
  const map = {
    pending: "รอชำระ",
    partial: "ชำระบางส่วน",
    paid: "ชำระแล้ว",
    overdue: "ค้างชำระ",
  };
  return map[status] || status;
};

const statusBadgeClass = (status) => {
  const map = {
    pending: "text-bg-secondary",
    partial: "text-bg-warning",
    paid: "text-bg-success",
    overdue: "text-bg-danger",
  };
  return map[status] || "text-bg-light";
};
</script>
<template>
  <div class="card border-0 shadow-sm rounded-4 h-100">
    <div class="card-body p-4">
      <div class="d-flex align-items-center justify-content-between mb-4">
        <div>
          <h5 class="fw-bold mb-1">ข้อมูลใบแจ้งหนี้</h5>
          <div class="text-muted small">รายละเอียดเอกสารและรอบบิล</div>
        </div>
        <span
          class="badge rounded-pill"
          :class="statusBadgeClass(invoice.status)"
        >
          {{ statusText(invoice.status) }}
        </span>
      </div>

      <div class="row g-3">
        <div class="col-md-6" v-for="item in infoItems" :key="item.label">
          <div class="label-text">{{ item.label }}</div>
          <div class="value-text">{{ item.value }}</div>
        </div>
      </div>

      <div class="mt-4 pt-4 border-top">
        <div class="label-text mb-2">หมายเหตุ</div>
        <div class="text-muted">{{ invoice.note || "-" }}</div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.label-text {
  font-size: 0.82rem;
  color: #6c757d;
  margin-bottom: 0.25rem;
}
.value-text {
  font-weight: 600;
}
</style>
